import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { adaptProviderSourceFromResponse, TProviderSource, TProviderSourceResponse } from './provider-source.type';
import { adaptBrandSourceFromResponse, TBrandSource, TBrandSourceResponse } from './brand-source.type';


export const ProductShortListSortCol = {
	NAME: 'name',
	SERIAL_NUMBER: 'serialNumber',
	BRAND: 'brand',
	PROVIDER: 'provider',
};

export type TProductShortListSortCol = TTableSortCols<typeof ProductShortListSortCol>;

export type TProductShortListQuery = {
	limit: number;
	offset: number;
	search?: string;
	searchBrandName?: string;
	searchSerialNumber?: string;
	searchProvider?: string;
	searchName?: string;
	sort?: TTableSort;
	sortCol?: TProductShortListSortCol;
	userNickname: string;
	serialNumber: string;
};

export type TProductShortListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
	user_nickname?: string;
	serial_number?: string;
};

export function adaptProductShortListQueryToRequest(data?: TProductShortListQuery): TProductShortListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		userNickname,
		sortCol,
		...restFields
	} = data;

	return {
		user_nickname: userNickname,
		sort_col: sortCol,
		...restFields
	};
}

export type TProductShort = {
  id: string;
  serialNumber: string;
  name: string;
  provider: TProviderSource;
  brand: TBrandSource;
};

export type TProductShortResponse = {
  id: string;
  serial_number: string;
  name: string;
	provider: TProviderSourceResponse;
  brand: TBrandSourceResponse;
};

export type TProductShortListResponse = TListResponse<TProductShortResponse>;

export type TProductShortList = TListResponse<TProductShort>;

export type TProductShortPayloadRequest = {
	serialNumber: string;
	userNickname: string;
};

export type TProductShortRequest = {
	serial_number: string;
	user_nickname: string;
};

export type TProductShortHistoryItem = TProductShortPayloadRequest & {
	date: string;
	key: string;
};

export function adaptProductShortFromListResponse(data: TProductShortListResponse): TProductShortList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptProductShortFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptProductShortFromResponse(data: TProductShortResponse): TProductShort {
	const {
		serial_number: serialNumber,
		name = '',
		provider: providerRaw,
		brand: brandRaw,
	} = data;

	const provider = adaptProviderSourceFromResponse(providerRaw);
	const brand = adaptBrandSourceFromResponse(brandRaw);
	const id = `${serialNumber}-${brand.id}-${provider.id}`;

	return {
		id,
		serialNumber,
		name,
		provider,
		brand,
	};
}

export function adaptProductShortToRequest(data: TProductShortPayloadRequest): TProductShortRequest {
	const {
		serialNumber,
		userNickname,
	} = data;

	return {
		serial_number: serialNumber,
		user_nickname: userNickname,
	};
}
